module.exports = __webpack_public_path__ + "img/def1f4f.png";